import React from 'react'
import { isNull } from 'lodash-es'
import { useTranslation } from 'react-i18next'
import Box from '@node-space/storybook-components/dist/Box'
import { Callout } from '@node-space/storybook-components/dist/Callout'
import { ProofOfPaymentButton } from 'components/ProofOfPaymentButton/ProofOfPaymentButton'
import { TransactionType, TTransactionSubType } from 'types/transaction/TransactionType'
import { getSupportedPaymentTypes, getTransactionStatus } from 'utils/utils'

interface ProofOfPaymentContainerProps {
  transactionType?: string
  transactionSubType?: TTransactionSubType | string
  status?: string
  externalReference?: string
  hasProofOfPayment?: boolean
  isLink?: boolean
}

export const ProofOfPaymentContainer = ({
  transactionType,
  transactionSubType,
  status,
  externalReference,
  hasProofOfPayment,
  isLink = false,
}: ProofOfPaymentContainerProps) => {
  const { t } = useTranslation()
  const cryptoWithdrawalSubType = getSupportedPaymentTypes().CRYPTO_WITHDRAWAL

  const failedStatuses = getTransactionStatus()?.failedStatuses
  const pendingStatuses = getTransactionStatus()?.pendingStatuses

  const isFailedTransaction = failedStatuses?.includes(status)

  const isFiatWithdrawal =
    transactionType === TransactionType.USER_WITHDRAWAL &&
    transactionSubType !== cryptoWithdrawalSubType

  let calloutText

  if (isNull(hasProofOfPayment)) {
    calloutText = t('notBankingAPIWallet')
  } else if (pendingStatuses?.includes(status)) {
    calloutText = t('transactionInProgress')
  }

  return (
    <Box>
      {!isFailedTransaction && isFiatWithdrawal && hasProofOfPayment && (
        <Box {...(!isLink && { paddingX: 16, paddingB: 16 })}>
          <ProofOfPaymentButton isLink={isLink} externalReference={externalReference} />
        </Box>
      )}

      {!isFailedTransaction && isFiatWithdrawal && calloutText && (
        <Box {...(!isLink && { paddingX: 16, paddingB: 16 })}>
          <Callout state="info" message={calloutText} />
        </Box>
      )}
    </Box>
  )
}

export default ProofOfPaymentContainer
